module.exports = __webpack_public_path__ + "img/54.e4cacd1.jpg";